
import ChargesComponent from "../components/Banks/ChargesComponent";

export default function ChargesPage(){

    return (
      <ChargesComponent/>
    );
}